import React from 'react';
import { Paper, Typography, Box, Grid, TextField, FormControlLabel, Radio, RadioGroup, FormControl } from '@material-ui/core';

// Bloc de validation légale : dépassement 39h, respect des repos et signature
export default function ValidationCard({ classes, isMobile, isLocked, heuresSup, meta = {}, onChangeMeta }) {
    const align = isMobile ? 'center' : 'left';

    return (
        <Paper className={classes.headerCard}>
            <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold', textAlign: align }}>Validation et engagements</Typography>

            <Box className={classes.validationBlock}>
                <Grid container alignItems="center" justify={isMobile ? 'center' : 'flex-start'} spacing={2}>
                    <Grid item xs={12} sm={7} style={{ textAlign: align }}>
                        <Typography variant="body1">
                            Heures accomplies au-delà de 39h : <b>{heuresSup} h</b> (automatique)
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={5} style={{ textAlign: align }}>
                        <FormControl component="fieldset">
                            <Typography variant="body2" color="textSecondary">Autorisation préalable Direction :</Typography>
                            <RadioGroup
                                name="autorisationDir" // <-- AJOUT ICI
                                row={!isMobile}
                                value={meta.autorisationDir || ''}
                                onChange={e => onChangeMeta({ autorisationDir: e.target.value })}
                                style={{ justifyContent: isMobile ? 'center' : 'flex-start' }}
                            >
                                <FormControlLabel value="oui" control={<Radio color="primary" disabled={!!isLocked} />} label="Oui" />
                                <FormControlLabel value="non" control={<Radio color="primary" disabled={!!isLocked} />} label="Non" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </Grid>
            </Box>

            <Box className={classes.validationBlock} style={{ textAlign: align }}>
                <FormControl component="fieldset" fullWidth>
                    <Typography variant="body1" gutterBottom>
                        Repos quotidien (11h) et hebdomadaire (39h) respectés ?
                    </Typography>
                    <RadioGroup
                        name="reposRespectes" // <-- AJOUT ICI
                        row
                        value={meta.reposRespectes || ''}
                        onChange={e => onChangeMeta({ reposRespectes: e.target.value })}
                        style={{ justifyContent: isMobile ? 'center' : 'flex-start' }}
                    >
                        <FormControlLabel value="oui" control={<Radio color="primary" disabled={!!isLocked} />} label="Oui" />
                        <FormControlLabel value="non" control={<Radio color="primary" disabled={!!isLocked} />} label="Non" />
                    </RadioGroup>
                </FormControl>
                {meta.reposRespectes === 'non' && (
                    <Box mt={1}>
                        <TextField
                            label="Précisions"
                            value={meta.remarquesRepos || ''}
                            onChange={e => onChangeMeta({ remarquesRepos: e.target.value })}
                            variant="outlined"
                            fullWidth
                            size="small"
                            disabled={!!isLocked}
                            className={classes.inputRounded}
                        />
                    </Box>
                )}
            </Box>

            <Box mt={3}>
                <TextField
                    id="signature-field"
                    label="Signature du Salarié (Tapez Prénom & Nom)"
                    value={meta.signatureName || ''}
                    onChange={e => onChangeMeta({ signatureName: e.target.value })}
                    variant="outlined"
                    fullWidth
                    required
                    disabled={!!isLocked}
                    className={classes.inputRounded}
                />
            </Box>
        </Paper>
    );
}